import { configureStore, combineReducers } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import { persistReducer, persistStore } from 'redux-persist'
import thunk from 'redux-thunk'

import settingsReducer from './reducers/settingsSlice'
import profileReducer from './reducers/profileSlice'
import subscriptionAddReducer from './reducers/subscriptionAddSlice'

const persistConfig = {
  key: 'root',
  storage,
}

const rootReducer = combineReducers({ 
  profile: profileReducer,
  settings: settingsReducer,
  subscriptionAdd: subscriptionAddReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk]
})

export const persistor = persistStore(store)